var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_495"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_496"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_497"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_498"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_499"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_500"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_501"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_502"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_503"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_504"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_507"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_505"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_506"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_508"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_509"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_510"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_511"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_499"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#56bca6",
    result: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 244,
    height: 244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_501"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#197561",
    result: "color-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_502"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#197561",
    result: "color-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_522",
    "data-name": "Groupe 522",
    transform: "translate(-570 -570)",
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495-2",
    "data-name": "Rectangle 495",
    width: 13.013,
    height: 43.378,
    transform: "translate(596.568 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495-3",
    "data-name": "Rectangle 495",
    width: 13.013,
    height: 43.378,
    transform: "translate(26.57 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496-2",
    "data-name": "Rectangle 496",
    width: 13.013,
    height: 8.676,
    transform: "translate(683.324 678.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496-3",
    "data-name": "Rectangle 496",
    width: 13.013,
    height: 8.676,
    transform: "translate(113.32 108.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497-2",
    "data-name": "Rectangle 497",
    width: 13.013,
    height: 8.676,
    transform: "translate(683.324 661.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_497)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497-3",
    "data-name": "Rectangle 497",
    width: 13.013,
    height: 8.676,
    transform: "translate(113.32 91.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498-2",
    "data-name": "Rectangle 498",
    width: 13.013,
    height: 8.674,
    transform: "translate(661.635 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498-3",
    "data-name": "Rectangle 498",
    width: 13.013,
    height: 8.674,
    transform: "translate(91.63 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499-2",
    "data-name": "Rectangle 499",
    width: 13.013,
    height: 8.676,
    transform: "translate(661.635 661.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499-3",
    "data-name": "Rectangle 499",
    width: 13.013,
    height: 8.676,
    transform: "translate(91.63 91.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500-2",
    "data-name": "Rectangle 500",
    width: 13.013,
    height: 8.674,
    transform: "translate(639.946 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500-3",
    "data-name": "Rectangle 500",
    width: 13.013,
    height: 8.674,
    transform: "translate(69.95 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501-2",
    "data-name": "Rectangle 501",
    width: 13.013,
    height: 8.676,
    transform: "translate(661.635 678.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501-3",
    "data-name": "Rectangle 501",
    width: 13.013,
    height: 8.676,
    transform: "translate(91.63 108.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502-2",
    "data-name": "Rectangle 502",
    width: 13.013,
    height: 8.674,
    transform: "translate(683.324 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502-3",
    "data-name": "Rectangle 502",
    width: 13.013,
    height: 8.674,
    transform: "translate(113.32 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503-2",
    "data-name": "Rectangle 503",
    width: 13.013,
    height: 8.674,
    transform: "translate(705.013 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503-3",
    "data-name": "Rectangle 503",
    width: 13.013,
    height: 8.674,
    transform: "translate(135.01 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504-2",
    "data-name": "Rectangle 504",
    width: 13.018,
    height: 8.676,
    transform: "translate(705.013 678.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_504)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504-3",
    "data-name": "Rectangle 504",
    width: 13.018,
    height: 8.676,
    transform: "translate(135.01 108.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507-2",
    "data-name": "Rectangle 507",
    width: 13.013,
    height: 8.676,
    transform: "translate(639.946 661.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507-3",
    "data-name": "Rectangle 507",
    width: 13.013,
    height: 8.676,
    transform: "translate(69.95 91.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505-2",
    "data-name": "Rectangle 505",
    width: 13.018,
    height: 8.676,
    transform: "translate(705.013 661.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505-3",
    "data-name": "Rectangle 505",
    width: 13.018,
    height: 8.676,
    transform: "translate(135.01 91.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506-2",
    "data-name": "Rectangle 506",
    width: 121.457,
    height: 13.013,
    transform: "translate(596.568 622.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506-3",
    "data-name": "Rectangle 506",
    width: 121.457,
    height: 13.013,
    transform: "translate(26.57 52.6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508-2",
    "data-name": "Rectangle 508",
    width: 13.013,
    height: 8.676,
    transform: "translate(618.257 678.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508-3",
    "data-name": "Rectangle 508",
    width: 13.013,
    height: 8.676,
    transform: "translate(48.26 108.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509-2",
    "data-name": "Rectangle 509",
    width: 13.013,
    height: 8.674,
    transform: "translate(618.257 644.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509-3",
    "data-name": "Rectangle 509",
    width: 13.013,
    height: 8.674,
    transform: "translate(48.26 74.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510-2",
    "data-name": "Rectangle 510",
    width: 13.013,
    height: 8.676,
    transform: "translate(639.946 678.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_510)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510-3",
    "data-name": "Rectangle 510",
    width: 13.013,
    height: 8.676,
    transform: "translate(69.95 108.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511-2",
    "data-name": "Rectangle 511",
    width: 13.013,
    height: 8.676,
    transform: "translate(618.257 661.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Rectangle_511)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511-3",
    "data-name": "Rectangle 511",
    width: 13.013,
    height: 8.676,
    transform: "translate(48.26 91.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_499-2",
    "data-name": "Trac\\xE9 499",
    d: "M595.405,591.065V579.848l-15.557,15.557h11.217a4.34,4.34,0,0,0,4.34-4.34Zm0,0",
    transform: "translate(-3.173 -3.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 570, 570)",
    filter: "url(#Trac\\xE9_499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_499-3",
    "data-name": "Trac\\xE9 499",
    d: "M595.405,591.065V579.848l-15.557,15.557h11.217a4.34,4.34,0,0,0,4.34-4.34Zm0,0",
    transform: "translate(-573.17 -573.17)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_521",
    "data-name": "Groupe 521",
    transform: "translate(570 570)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_520",
    "data-name": "Groupe 520",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_501-2",
    "data-name": "Trac\\xE9 501",
    d: "M575.137,805.039h144.1a60.638,60.638,0,0,1-16.867-30.362H644.544a4.338,4.338,0,1,1,0-8.676h56.61c-.1-1.44-.22-2.873-.22-4.34s.117-2.9.22-4.336h-56.61a4.338,4.338,0,1,1,0-8.676h57.831a60.062,60.062,0,0,1,2.632-8.676H666.233a4.336,4.336,0,1,1,0-8.673H709.15a60.944,60.944,0,0,1,6.073-8.676H644.544a4.338,4.338,0,1,1,0-8.676h79.675a60.633,60.633,0,0,1,20.093-10.455V575.137a4.338,4.338,0,0,0-4.34-4.336H601.166V588.15a13.016,13.016,0,0,1-13.016,13.016H570.8V800.7a4.334,4.334,0,0,0,4.336,4.336Zm69.406-21.689h39.038a4.338,4.338,0,1,1,0,8.676H644.544a4.338,4.338,0,1,1,0-8.676Zm0-52.051h4.336a4.336,4.336,0,0,1,0,8.673h-4.336a4.336,4.336,0,1,1,0-8.673ZM588.15,622.855a8.676,8.676,0,0,1,8.676-8.676H718.283a8.675,8.675,0,0,1,8.676,8.676v65.067a8.674,8.674,0,0,1-8.676,8.673H596.826a8.675,8.675,0,0,1-8.676-8.673Z",
    transform: "translate(-570.258 -570.258)",
    fill: "#56bca6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_501-3",
    "data-name": "Trac\\xE9 501",
    d: "M575.137,805.039h144.1a60.638,60.638,0,0,1-16.867-30.362H644.544a4.338,4.338,0,1,1,0-8.676h56.61c-.1-1.44-.22-2.873-.22-4.34s.117-2.9.22-4.336h-56.61a4.338,4.338,0,1,1,0-8.676h57.831a60.062,60.062,0,0,1,2.632-8.676H666.233a4.336,4.336,0,1,1,0-8.673H709.15a60.944,60.944,0,0,1,6.073-8.676H644.544a4.338,4.338,0,1,1,0-8.676h79.675a60.633,60.633,0,0,1,20.093-10.455V575.137a4.338,4.338,0,0,0-4.34-4.336H601.166V588.15a13.016,13.016,0,0,1-13.016,13.016H570.8V800.7a4.334,4.334,0,0,0,4.336,4.336Zm69.406-21.689h39.038a4.338,4.338,0,1,1,0,8.676H644.544a4.338,4.338,0,1,1,0-8.676Zm0-52.051h4.336a4.336,4.336,0,0,1,0,8.673h-4.336a4.336,4.336,0,1,1,0-8.673ZM588.15,622.855a8.676,8.676,0,0,1,8.676-8.676H718.283a8.675,8.675,0,0,1,8.676,8.676v65.067a8.674,8.674,0,0,1-8.676,8.673H596.826a8.675,8.675,0,0,1-8.676-8.673Z",
    transform: "translate(-570.26 -570.26)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_502-2",
    "data-name": "Trac\\xE9 502",
    d: "M775.6,827.653A52.053,52.053,0,1,0,827.653,775.6,52.056,52.056,0,0,0,775.6,827.653Zm27.3,14.287a4.337,4.337,0,0,1,6.135,0l9.036,9.033L845.6,803.8a4.338,4.338,0,1,1,7.5,4.34l-30.365,52.051a4.327,4.327,0,0,1-3.193,2.118,4.9,4.9,0,0,1-.553.053,4.341,4.341,0,0,1-3.069-1.271L802.9,848.071a4.333,4.333,0,0,1,0-6.131Zm0,0",
    transform: "translate(-636.25 -636.25)",
    fill: "#56bca6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_502-3",
    "data-name": "Trac\\xE9 502",
    d: "M775.6,827.653A52.053,52.053,0,1,0,827.653,775.6,52.056,52.056,0,0,0,775.6,827.653Zm27.3,14.287a4.337,4.337,0,0,1,6.135,0l9.036,9.033L845.6,803.8a4.338,4.338,0,1,1,7.5,4.34l-30.365,52.051a4.327,4.327,0,0,1-3.193,2.118,4.9,4.9,0,0,1-.553.053,4.341,4.341,0,0,1-3.069-1.271L802.9,848.071a4.333,4.333,0,0,1,0-6.131Zm0,0",
    transform: "translate(-636.25 -636.25)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderGreen);
export default __webpack_public_path__ + "static/media/calender-green.e58b0c16567cd1aa63977070765e30cd.svg";
export { ForwardRef as ReactComponent };